import { memo } from "react";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { EmptyValue } from "@design-system/EmptyValue/EmptyValue";
import { EntityDisplay } from "@components/entity/EntityDisplay";
import { useEntitiesById } from "@hooks/useEntities";
import { HistoryDetailsBaseRow } from "./historyDetailsBaseRow";

interface HistoryDetailsEntityDisplayCellProps {
    row: { original: HistoryDetailsBaseRow };
}

export const HistoryDetailsEntityDisplayCell = memo(
    ({ row }: HistoryDetailsEntityDisplayCellProps) => {
        const { entityId } = row.original;
        const allEntities = useEntitiesById();
        const entity =
            entityId !== null ? allEntities.get(entityId) : undefined;

        if (!entity) {
            return (
                <ViewTableCell>
                    <EmptyValue />
                </ViewTableCell>
            );
        }

        return (
            <ViewTableCell>
                <EntityDisplay entity={entity} />
            </ViewTableCell>
        );
    },
);

HistoryDetailsEntityDisplayCell.displayName = "HistoryDetailsEntityDisplayCell";
